<div class="container-fluid">
  <h1 mat-dialog-title>{{ dialogTitle }}</h1>
  <div class="text-center" *ngIf="data.props.length>1">
    {{data.props.length}} biens sélectionnés
  </div>
  <div mat-dialog-content>
    <form [formGroup]="attrsForm" (ngSubmit)="onSubmit()">
      <div [class]="attrs.controls.length==0 ? 'text-center mt-3 mb-3' : 'text-right mt-3 mb-3'">
        <button mat-mini-fab color="primary" class="ml-2" appTooltip="Sélectionner un attribut"
          [matMenuTriggerFor]="menuAttrGrp">
          <mat-icon>add</mat-icon>
        </button>

        <mat-menu #menuAttrGrp="matMenu">
          <ng-template matMenuContent>
            <button *ngFor="let group of filterDisplayAttributeGroups" mat-menu-item [matMenuTriggerFor]="menuAttr"
              [matMenuTriggerData]="{group: group.code}">{{group.display.name}}</button>
          </ng-template>
        </mat-menu>

        <mat-menu #menuAttr="matMenu">
          <ng-template matMenuContent let-group="group">
            <button *ngFor="let attr of this.filterDisplayAttributes[group]" [matMenuTriggerFor]="menuAttrValues"
              [matMenuTriggerData]="{attr: attr}" [disabled]="filterAttributesSelected[attr.code]"
              mat-menu-item>{{attr.display.name}}</button>
          </ng-template>
        </mat-menu>

        <mat-menu #menuAttrValues="matMenu">
          <ng-template matMenuContent let-attr="attr">
            <button *ngIf="!filterDisplayAttributeValues[attr.code]; else displayValues"
              (click)="addFilterAttributeValue(attr,null,null)" mat-menu-item>Entrer une valeur</button>
            <ng-template #displayValues>
              <button *ngFor="let attrValue of filterDisplayAttributeValues[attr.code]"
                (click)="addFilterAttributeValue(attr,attrValue.value,attrValue.name)"
                mat-menu-item>{{attrValue.name}}</button>
            </ng-template>
          </ng-template>
        </mat-menu>
      </div>
      <div class="form-group text-center">
        <div *ngIf="attrs.controls.length==0 else formField" class="p-2 font-italic">Ajouter des attributs à modifier
        </div>
        <ng-template #formField>
          <div formArrayName="attrs" *ngFor="let attr of attrs.controls; let i = index">
            <div [formGroupName]="i" class="row">
              <div>
                <mat-form-field *ngIf="!attr.get('displayValue').value; else filledField" class="">
                  <mat-label>{{attr.get('displayName').value}}</mat-label>
                  <input matInput placeholder="" type="text" required formControlName="value" />
                  <mat-error>
                    <span *ngIf="attr.get('value').hasError('required')">Veuillez saisir une valeur</span>
                  </mat-error>
                </mat-form-field>
                <ng-template #filledField>
                  <mat-form-field class="">
                    <mat-label>{{attr.get('displayName').value}}</mat-label>
                    <input matInput placeholder="" type="text" disabled required
                      [value]="attr.get('displayValue').value" />
                  </mat-form-field>
                </ng-template>
              </div>
              <div class="pt-2">
                <button appTooltip="Effacer la ligne" (click)="deleteAttr(i)" color="primary">
                  <mat-icon aria-label="Delete">delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

      <div class="text-center">
        <button mat-flat-button class="m-1" color="primary" type="submit" [disabled]="attrs.length<1">
          Valider
        </button>
        <button mat-flat-button class="m-1" color="primary" mat-dialog-close>
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
